import React from "react";
import Link from "gatsby-link";

import Logo from "./../../images/logo-nav.png";

const Navbar = ({ pages }) => {
  return (
    <nav className="navbar navbar-default navbar-fixed-top nav-transparent overlay-nav sticky-nav nav-white nav-dark-transparent">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-2 navbar-header pull-left" style={{ clear: "left" }}>
            <Link to="/" className="navbar-brand">
              <img alt="Moon Beyond Creative Co - Visual Design Agency" src={Logo} className="logo" />
            </Link>
          </div>
          <div className="navbar-header col-sm-4 col-xs-2 pull-right">
            <button type="button" className="navbar-toggle" data-toggle="collapse" data-target=".navbar-collapse">
              <span className="sr-only">Toggle navigation</span>
              <span className="icon-bar" />
              <span className="icon-bar" />
              <span className="icon-bar" />
            </button>
          </div>
          <div className="col-md-8 no-padding-right accordion-menu text-right">
            <div className="navbar-collapse collapse">
              <ul id="accordion" className="nav navbar-nav navbar-right panel-group">
                <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-home">
                  <Link to="/">Home</Link>
                </li>
                {pages
                  .filter(a => a.title !== "Home")
                  .map((a, i) => (
                    <li className="menu-item menu-item-type-post_type menu-item-object-page" key={i}>
                      <Link to={`/${a.object_slug}`} activeClassName="activeNavbarLink">
                        {a.title}
                      </Link>
                    </li>
                  ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;



// WEBPACK FOOTER //
// ./src/components/Navbar/index.js